// extracted by mini-css-extract-plugin
export default {"wrapper":"Image_wrapper__0LWvU","img":"Image_img__OcODP","skeleton":"Image_skeleton__MpVEk"};